import { useEffect, useState } from "react";
import { fetchAPI, postAPI } from "../api/api";
import { Chip } from "./Chip";
import { HorizontalLayout } from "../components/layout";
import { StandardButton } from "../atoms/buttons";
import { isDisabled } from "@testing-library/user-event/dist/utils";

export const SuggestedSkillsPanel = ({currentSkillCount, suggestedSkills, onClose, loading, handleAddSkills,}) => {
    const [selectedSkillIds, setSelectedSkillIds] = useState([]);
    const maxSelectable = 10 - currentSkillCount;
    const chipIsDisabled = maxSelectable === 0
    const toggleSkill = (id) => {
        setSelectedSkillIds((prev) => {
        const alreadySelected = prev.includes(id);
        if (alreadySelected) {
        return prev.filter((s) => s !== id);
        }
        if (prev.length < maxSelectable) {
        return [...prev, id]; 
        }
        return prev; 
    });
    };

    const isSelected = (id) => selectedSkillIds.includes(id);

    const selectedSkills = suggestedSkills.filter((skill) =>
        selectedSkillIds.includes(skill.id_skill)
    );

    const isDisabled = selectedSkillIds.length === 0 || loading;
    return (
        <>
        <h3 className="small-text-dark semi-bold">Skills Suggesties</h3>
        <p className="small-text-light standard-small-margin-bottom">Selecteer skill(s):</p>
        <div
            style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            marginBottom: "1.5rem",
            }}
        >
            {suggestedSkills.map((skill) => (
            <Chip
                key={skill.id_skill}
                label={skill.skill_name}
                onClick={() => toggleSkill(skill.id_skill)}
                variant={isSelected(skill.id_skill) ? "suggest-selected" : "suggest-not-selected"}
                iconEnd={isSelected(skill.id_skill) ? "check" : ""}
                size="medium"
                disabled={chipIsDisabled}
            />
            ))}
        </div>
        <HorizontalLayout style={{ justifyContent: "flex-end" }}>
            <StandardButton
            title="Annuleren"
            backgroundColor="transparent"
            textColor="standard-text-color-light"
            onClick={onClose}
            />
            <StandardButton
                title="Skills toevoegen"
                onClick={() => handleAddSkills(selectedSkills)}
                isDisabled={isDisabled}
                className={isDisabled ? "disabled" : ""}
            />
        </HorizontalLayout>
        </>
    );
};